import Store from 'repatch';
import State from '../core/State';
import { UserId } from '@kaizenplatform/kaizen-id-entity';
import Work, { WorkId } from '../entity/Work';
import ErrorPresenter from '../service/ErrorPresenter';
import WorkWebApi from '../service/persistent/WorkWebApi';
import { startFetchingWork, finishFetchingWork, disposeWork, setWork } from '../reducer/work';
import { History } from 'history';

class ShowWorkUsecase {
  private readonly store: Store<State>;
  private readonly history: History;
  private readonly errorPresenter: ErrorPresenter;
  private readonly workWebApi: WorkWebApi;

  constructor({
    store,
    history,
    errorPresenter,
    workWebApi,
  }: {
    store: Store<State>;
    history: History;
    errorPresenter: ErrorPresenter;
    workWebApi: WorkWebApi;
  }) {
    this.store = store;
    this.history = history;
    this.errorPresenter = errorPresenter;
    this.workWebApi = workWebApi;
  }

  public prepareWork = async (workId: WorkId): Promise<void> => {
    this.store.dispatch(startFetchingWork());

    let work: Work;

    try {
      work = await this.workWebApi.getWorkById(workId);
    } catch (err) {
      this.store.dispatch(finishFetchingWork());
      this.store.dispatch(disposeWork());
      this.errorPresenter.showAsFatal(err);
      return;
    }

    this.store.dispatch(setWork(work));
    this.store.dispatch(finishFetchingWork());
  };

  public disposeWork = (userId: UserId): void => {
    this.store.dispatch(disposeWork());
    this.history.push(`/users/${userId}`, { scroll: false });
  };
}

export default ShowWorkUsecase;
